let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iedV6")).then(() => parcelRequire('alLvI'));